import React from 'react'

const Dashboard = () => {
    return (
        <div>
            hello
        </div>
    )
}

export default Dashboard
